/**
 * 判断根节点中是否包含 document.activeElement 元素为特殊dom节点
 * 目前用于 ESC 关闭弹窗前用户可能正在输入内容
 * @param root
 * @returns
 */
export const isInnerActiveEle = (root: HTMLElement): boolean => {
  // 添加 activeElement 在root 树中的现实
  const curActiveEle = document?.activeElement;
  return root?.contains(curActiveEle) && activeEleIsEditDom();
};

/**
 * 判断页面当前 activeElement 是否为 input、textarea、富文本
 * @returns boolean
 */
export const activeEleIsEditDom = (): boolean => {
  // fix 详情页按 ESC 会关掉详情页（在编辑态/评论输入禁用）
  // 编辑态暂时只考虑input、textarea、富文本是 document.activeElement

  const curActiveEle = document?.activeElement;
  const tags = ['input', 'textarea'];
  const curTag = curActiveEle?.tagName?.toLowerCase() ?? '';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const isContenteditable = curActiveEle?.contentEditable === 'true';
  // activeEle 是 input 或 textarea
  // activeEle 是富文本编辑器
  return tags.includes(curTag) || isContenteditable;
};

/**
 *  获取字符串的页面像素宽度
 *  @param  str 字符串
 *  @param  fontsize 字体尺寸 默认14px
 *  @returns number
 */
export const getTextWidth = (str: string, fontSize = '14px') => {
  let result = 10;
  const ele: HTMLSpanElement = document.createElement('span');
  ele.innerText = str;
  ele.style.fontSize = fontSize;
  document.documentElement.append(ele);

  result = ele.offsetWidth;

  document.documentElement.removeChild(ele);
  return result;
};

export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function findParentByClassName(className: string, element: HTMLElement, selfInclude: boolean = false) {
  let parent = selfInclude ? element : element.parentElement;
  while (parent) {
    if (parent.classList.contains(className)) {
      return parent;
    }
    else {
      parent = parent.parentElement
    }
  }
  return parent;
}

export function getRelativeContainerForElement(ele: Element) {
  let parent: Element = ele;
  do {
    parent = parent.parentElement;
    if (!parent) {
      return null;
    }
    if (getComputedStyle(parent).position === 'relative') {
      return parent;
    }
  } while (parent);
  return null;
}

export function isElementVisible(element) {
  if (!element) {
    return false;
  }
  const style = window.getComputedStyle(element);
  return (
    style.display !== 'none' &&
    style.visibility !== 'hidden' &&
    element.offsetWidth > 0 &&
    element.offsetHeight > 0
  );
}
